<template>
	<div :class="{ 'viewer-container': true, 'page-height': viewType != 'embed' }">
		<iframe
			:src="src"
			class="embed frame"
			v-if="viewType == 'path' || viewType == 'external'"></iframe>
		<div class="embed" v-if="viewType == 'embed'"><div v-html="embedHtml"></div></div>
	</div>
</template>
<script>
	import { ref, inject, onMounted, computed } from "vue";
	export default {
		props: {
			uri: {
				type: String,
				default: ""
			},
			embed: {
				type: String,
				default: ""
			},
			viewType: {
				type: String,
				default: "false"
			}
		},
		setup(props, context) {
			const loading = ref(true);
			const domain = ref(process.env.VUE_APP_VIEWER_URI);

			const embedHtml = ref(props.embed);

			const src = computed(() => {
				if (props.viewType === "external") {
					return props.uri;
				} else {
					let relativePath = props.uri;
					if (props.uri.startsWith("/")) {
						relativePath = props.uri.substring(1);
					}
					return domain.value + relativePath;
				}
			});

			const LoadScript = (src, async, defer) => {
				const promise = new Promise((resolve, reject) => {
					const script = document.createElement("script");
					script.setAttribute("src", src);
					script.onerror = () => {
						return reject();
					};
					script.onload = () => {
						return resolve();
					};
					if (async) script.async = true;
					if (defer) script.defer = true;
					document.head.appendChild(script);
				});
				return promise;
			};

			const TryLoadScripts = () => {
				const regex = /<script[^>]*src\s*=\s*(['"]?)([^"'>\s]+)\1[^>]*>\s*<\/script>/g;
				const matches = [...embedHtml.value.matchAll(regex)];
				for (const match of matches) {
					const isDefer = /\bdefer\b/.test(match[0]);
					const isAsync = /\basync\b/.test(match[0]);

					const source = match[2];
					if (source) {
						LoadScript(source, isAsync, isDefer);
					} else {
						console.error("Found a match, but was unable to extract src element!", match);
					}
				}
			};

			onMounted(() => {
				TryLoadScripts();
			});

			return {
				loading,
				domain,
				src,
				embedHtml
			};
		}
	};
</script>

<style lang="scss" scoped>
	.viewer-container {
		display: flex;
		width: 100%;
		overflow: hidden;

		& > .frame {
			flex-grow: 1;
			border: none;
			margin: 0;
			padding: 0;
		}
	}
	.page-height {
		height: calc(100vh - 250px);
	}
</style>
<style lang="scss" scoped>
	.viewer-container {
		& .embed {
			width: 100%;
		}
	}
</style>
